import React from 'react';

import { Select, SelectOption } from '@flixbus/honeycomb-react';

const DISPLAY_OPTIONS = [
	{ value: 1, label: '1 day' },
	{ value: 2, label: '2 days' },
	{ value: 3, label: '3 days' },
];

const DisplaySelector = ({ fieldControl, submitOnChange }) => {
	const renderOptions = (ops) => {
		return ops.map((opt) => (
			<SelectOption key={opt.value} value={opt.value}>
				{opt.label}
			</SelectOption>
		));
	};

	const handleOnSelect = (e) => {
		fieldControl.onChange(Number(e.target.value));
		submitOnChange();
	};

	return (
		<Select
			id="display-selector"
			label="Display"
			value={fieldControl.value}
			onChange={(e) => handleOnSelect(e)}
		>
			{renderOptions(DISPLAY_OPTIONS)}
		</Select>
	);
};

export default DisplaySelector;
